import script from "./UserLoginPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserLoginPage.vue?vue&type=script&lang=ts&setup=true"

import "./UserLoginPage.vue?vue&type=style&index=0&id=c57fc454&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c57fc454"]])

export default __exports__